import { render, staticRenderFns } from "./VActiveForm.vue?vue&type=template&id=09e0c285"
import script from "./VActiveForm.vue?vue&type=script&lang=js"
export * from "./VActiveForm.vue?vue&type=script&lang=js"
import style0 from "./VActiveForm.vue?vue&type=style&index=0&id=09e0c285&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports